import React from 'react';
import {
  CloudSourceSyncStatus,
  CloudSourceSyncStatusProps,
} from '@components/sources/sourceDetails/cloudSourceDetails/cloudSourceStatusTab/cloudSourceSyncStatus';
import { WithCloudSourcePipelineProps, useCloudSourceInfo } from './cloudSourcesInfo';

interface CloudSourceStatusProps extends Partial<CloudSourceSyncStatusProps> {
  showSourceIcon?: boolean;
}

const CloudSourceStatus = ({
  showSourceIcon,
  ...props
}: WithCloudSourcePipelineProps & CloudSourceStatusProps) => {
  const { status } = useCloudSourceInfo();
  return <CloudSourceSyncStatus status={status} {...props} />;
};

export default CloudSourceStatus as React.FC<Partial<CloudSourceStatusProps>>;
